
import { ref } from "vue";
import { usePlugin } from "@/plugins";

export default {
  name: "AppProfile",
  setup() {
    const { useState, onRouterReplace, onLogout, confirmation } = usePlugin();
    const expanded = ref(false);
    const onClick = (event: Event) => {
      expanded.value = !expanded.value;
      event.preventDefault();
    };
    const onConfirmLogout = () => onLogout();
    // const onConfirmLogout = () => {
    //   confirmation.require({
    //     header: "กรุณายืนยัน",
    //     message: "กรุณายืนยันเพื่อออกจากระบบ Sales Target",
    //     accept: () => onLogout(),
    //   });
    // };
    const state = useState();

    return {
      state,
      expanded,
      onClick,
      onConfirmLogout,
      // onNotification,
    };
  },
};
